import React, { useState } from "react";
import { calculateAdaptiveTrust } from "../../api/adaptiveTrustEngineService";
import { getUserBehaviorProfile } from "../../api/behaviorAnalyticsService";

export default function AdaptiveTrustEnginePage() {
    const [form, setForm] = useState({
        userId: 1,
        hasAiAnomaly: false,
        hasThreatPrediction: false,
        failedLoginCount: 0,
        failedTwoFactorCount: 0,
        unknownIp: false,
        suspiciousDevice: false,
    });

    const [result, setResult] = useState(null);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };
    const loadBehaviorProfile = async () => {
        try {
            setError("");

            const profile = await getUserBehaviorProfile(form.userId);

            setForm((prev) => ({
                ...prev,
                failedLoginCount: profile.failedLoginCount ?? 0,
                failedTwoFactorCount: profile.failedTwoFactorCount ?? 0,
                unknownIp: profile.unknownIp ?? false,
                suspiciousDevice: profile.suspiciousDevice ?? false,
            }));
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Failed to load behavior profile."
            );
        }
    };

    const handleCalculate = async () => {
        try {
            setError("");
            setResult(null);

            const data = await calculateAdaptiveTrust(form);
            setResult(data);
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Failed to calculate adaptive trust score."
            );
        }
    };
    const handleAutoCalculate = async () => {
        try {
            setError("");
            setResult(null);

            const profile = await getUserBehaviorProfile(form.userId);

            const updatedForm = {
                ...form,
                failedLoginCount: profile.failedLoginCount ?? 0,
                failedTwoFactorCount: profile.failedTwoFactorCount ?? 0,
                unknownIp: profile.unknownIp ?? false,
                suspiciousDevice: profile.suspiciousDevice ?? false,
            };

            setForm(updatedForm);

            const data = await calculateAdaptiveTrust(updatedForm);
            setResult(data);
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Failed to auto-calculate adaptive trust score."
            );
        }
    };
    return (
        <div className="max-w-3xl mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-2xl font-bold mb-4">
                Adaptive Trust Engine
            </h2>

            {error && <p className="text-red-600 mb-3">{error}</p>}

            <div className="space-y-3">
                <input
                    name="userId"
                    type="number"
                    value={form.userId}
                    onChange={handleChange}
                    className="border p-2 w-full rounded"
                    placeholder="User ID"
                />

                <input
                    name="failedLoginCount"
                    type="number"
                    value={form.failedLoginCount}
                    onChange={handleChange}
                    className="border p-2 w-full rounded"
                    placeholder="Failed login count"
                />

                <input
                    name="failedTwoFactorCount"
                    type="number"
                    value={form.failedTwoFactorCount}
                    onChange={handleChange}
                    className="border p-2 w-full rounded"
                    placeholder="Failed 2FA count"
                />

                <label className="block">
                    <input
                        name="hasAiAnomaly"
                        type="checkbox"
                        checked={form.hasAiAnomaly}
                        onChange={handleChange}
                        className="mr-2"
                    />
                    AI anomaly detected
                </label>

                <label className="block">
                    <input
                        name="hasThreatPrediction"
                        type="checkbox"
                        checked={form.hasThreatPrediction}
                        onChange={handleChange}
                        className="mr-2"
                    />
                    Threat prediction detected
                </label>

                <label className="block">
                    <input
                        name="unknownIp"
                        type="checkbox"
                        checked={form.unknownIp}
                        onChange={handleChange}
                        className="mr-2"
                    />
                    Unknown IP
                </label>

                <label className="block">
                    <input
                        name="suspiciousDevice"
                        type="checkbox"
                        checked={form.suspiciousDevice}
                        onChange={handleChange}
                        className="mr-2"
                    />
                    Suspicious device
                </label>
                <button
                    onClick={loadBehaviorProfile}
                    className="bg-purple-700 text-white px-4 py-2 rounded mr-2"
                >
                    Load Behavior Profile
                </button>
                <button
                    onClick={handleCalculate}
                    className="bg-blue-700 text-white px-4 py-2 rounded"
                >
                    Calculate Trust Score
                </button>
                <button
                    onClick={handleAutoCalculate}
                    className="bg-green-700 text-white px-4 py-2 rounded"
                >
                    Load Profile + Calculate
                </button>
            </div>

            {result && (
                <div className="mt-6 border rounded p-4 bg-gray-50">
                    <h3 className="text-xl font-bold mb-3">Result</h3>
                    <p><b>User ID:</b> {result.userId}</p>
                    <p><b>Score:</b> {result.score}</p>
                    <p><b>Risk Level:</b> {result.riskLevel}</p>
                    <p><b>Last Updated:</b> {new Date(result.lastUpdated).toLocaleString()}</p>
                </div>
            )}
        </div>
    );
}